var map = {
	"./default-order-labels.js": 586,
	"./es-mx/default-order-labels.js": 587,
	"./es/default-order-labels.js": 588,
	"./fr/default-order-labels.js": 589,
	"./pt/default-order-labels.js": 590
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 585;